<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="12" md="12">
        <b-form @submit.prevent>
          <b-card no-body class="invoice-preview-card">
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
              >
              <div class="invoice-number-date mt-md-0 mt-2">
                  <div class="d-flex align-items-center mb-1">
                    <h4 class="invoice-title mr-2">Invoice</h4>
                  </div>
                  <div class="d-flex align-items-center mb-2"></div>
                  <div v-if="form?.invoice_number" class="d-flex align-items-center mb-1">
                    <span class="title mr-2"> Number: </span>
                    <span>{{ form.invoice_number }}</span>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <span class="title mr-2"> Date: </span>
                    <flat-pickr
                      v-model="form.issue_date"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title mr-2"> Due Date: </span>
                    <flat-pickr
                      v-model="form.due_date"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title mr-2">Currency:</span>
                      <v-select
                        id="currency-id"
                        v-model="form.currency"
                        :options="currenciesOption"
                        :reduce="(option) => option.name"
                        label="name"
                        class="form-control"
                        style="border: none; margin-left: 31px;"
                        placeholder="Choose a currency"
                      />
                  </div>
                  <div class="d-flex flex-column mt-1">
                    <div>
                      <b-form-group label="Company Logo">
                        <div class="d-flex">
                          <b-form-checkbox
                            v-model="settings.invoice_logo_view.enabled"
                          >
                          </b-form-checkbox>

                          <b-form-file
                            accept="image/*"
                            @change="onLogoChange"
                            browse-text="Choose Logo"
                            placeholder="Upload logo"
                            :disabled="!settings.invoice_logo_view.enabled"
                          />
                        </div>
                        <small
                          v-if="validationErrors.invoice_logo_view"
                          class="text-danger font-weight-bold"
                          >{{ validationErrors.invoice_logo_view }}</small
                        >
                      </b-form-group>
                    </div>

                    <!-- Logo Preview (only if file is selected and logo is enabled) -->
                    <div
                      v-if="
                        settings.invoice_logo_view.enabled &&
                        form.invoice_logo_view
                      "
                      class="mt-2 text-center"
                    >
                      <img
                        :src="form.invoice_logo_view"
                        alt="Logo Preview"
                        style="height: 60px; max-width: 150px"
                      />
                    </div>
                  </div>
                </div>
                <!-- Header: Left Content - Company Info -->
                <div>
                  <div class="d-flex align-items-center mb-1">
                    <h6 class="mb-0">From:</h6>
                  </div>
                  <b-card>
                    <b-form-group label="Company Name">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="settings.company_name.enabled"
                        ></b-form-checkbox>
                        <b-form-input
                          v-model="form.company_name"
                          :disabled="!settings.company_name.enabled"
                        />
                      </div>
                      <small
                        v-if="validationErrors.company_name"
                        class="text-danger font-weight-bold"
                        >{{ validationErrors.company_name }}</small
                      >
                    </b-form-group>

                    <b-form-group label="Company Email">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="settings.company_email.enabled"
                        ></b-form-checkbox>
                        <b-form-input
                          v-model="form.company_email"
                          type="email"
                          :disabled="!settings.company_email.enabled"
                        />
                      </div>
                      <small
                        v-if="validationErrors.company_email"
                        class="text-danger font-weight-bold"
                        >{{ validationErrors.company_email }}</small
                      >
                    </b-form-group>

                    <b-form-group label="Company Phone">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="settings.company_phone.enabled"
                        ></b-form-checkbox>
                        <b-form-input
                          v-model="form.company_phone"
                          :disabled="!settings.company_phone.enabled"
                        />
                      </div>
                      <small
                        v-if="validationErrors.company_phone"
                        class="text-danger font-weight-bold"
                        >{{ validationErrors.company_phone }}</small
                      >
                    </b-form-group>

                    <b-form-group label="Company Address">
                      <div class="d-flex">
                        <b-form-checkbox
                          v-model="settings.company_address.enabled"
                        ></b-form-checkbox>
                        <b-form-textarea
                          v-model="form.company_address"
                          rows="2"
                          :disabled="!settings.company_address.enabled"
                        />
                      </div>
                      <small
                        v-if="validationErrors.company_address"
                        class="text-danger font-weight-bold"
                        >{{ validationErrors.company_address }}</small
                      >
                    </b-form-group>
                  </b-card>
                </div>

                <div
                  class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                >
                  <div>
                    <div class="d-flex align-items-center mb-1">
                      <h6 class="mb-0">Bill To:</h6>
                    </div>

                    <b-card>
                      <b-form-group label="Customer Name">
                        <div class="d-flex">
                          <b-form-checkbox
                            v-model="settings.customer_name.enabled"
                          ></b-form-checkbox>
                          <b-form-input
                            v-model="form.customer_name"
                            :disabled="!settings.customer_name.enabled"
                          />
                        </div>
                        <small
                          v-if="validationErrors.customer_name"
                          class="text-danger font-weight-bold"
                          >{{ validationErrors.customer_name }}</small
                        >
                      </b-form-group>

                      <b-form-group label="Customer Email">
                        <div class="d-flex">
                          <b-form-checkbox
                            v-model="settings.customer_email.enabled"
                          ></b-form-checkbox>
                          <b-form-input
                            v-model="form.customer_email"
                            type="email"
                            :disabled="!settings.customer_email.enabled"
                          />
                        </div>
                        <small
                          v-if="validationErrors.customer_email"
                          class="text-danger font-weight-bold"
                          >{{ validationErrors.customer_email }}</small
                        >
                      </b-form-group>

                      <b-form-group label="Customer Phone">
                        <div class="d-flex">
                          <b-form-checkbox
                            v-model="settings.customer_phone.enabled"
                          ></b-form-checkbox>
                          <b-form-input
                            v-model="form.customer_phone"
                            :disabled="!settings.customer_phone.enabled"
                          />
                        </div>
                        <small
                          v-if="validationErrors.customer_phone"
                          class="text-danger font-weight-bold"
                          >{{ validationErrors.customer_phone }}</small
                        >
                      </b-form-group>

                      <b-form-group label="Customer Address">
                        <div class="d-flex">
                          <b-form-checkbox
                            v-model="settings.customer_address.enabled"
                          ></b-form-checkbox>
                          <b-form-textarea
                            v-model="form.customer_address"
                            rows="2"
                            :disabled="!settings.customer_address.enabled"
                          />
                        </div>
                        <small
                          v-if="validationErrors.customer_address"
                          class="text-danger font-weight-bold"
                          >{{ validationErrors.customer_address }}</small
                        >
                      </b-form-group>
                    </b-card>
                  </div>
                </div>

                <!-- Header: Right Content - Invoice Info -->
                
              </div>
            </b-card-body>

            <!-- Invoice Items -->
            <b-card-body class="invoice-padding pt-0">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">Items</h6>
                <b-button variant="primary" size="sm" @click="addNewItem">
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span>Add Item</span>
                </b-button>
              </div>

              <b-table
                responsive
                :items="form.items"
                :fields="itemFields"
                class="invoice-item-table"
                :tbody-tr-class="rowClass"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(item_name)="data">
                  <b-form-input
                    v-model="data.item.item_name"
                    size="sm"
                    placeholder="Item Name"
                    required
                    :state="data.item.item_name ? true : false"
                  />
                </template>

                <template #cell(item_description)="data">
                  <b-form-input
                    v-model="data.item.item_description"
                    size="sm"
                    placeholder="Item Description"
                    :state="data.item.item_description ? true : false"
                  />
                </template>

                <template #cell(quantity)="data">
                  <b-form-input
                    v-model.number="data.item.quantity"
                    type="number"
                    min="1"
                    size="sm"
                    @input="calculateItemTotal(data.item)"
                    :state="data.item.quantity > 0 ? true : false"
                  />
                </template>

                <template #cell(unit_price)="data">
                  <b-form-input
                    v-model.number="data.item.unit_price"
                    type="number"
                    min="0"
                    step="0.01"
                    size="sm"
                    @input="calculateItemTotal(data.item)"
                    :state="data.item.unit_price >= 0 ? true : false"
                  />
                </template>

                <template #cell(total)="data">
                  {{ data.item.total }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="removeItem(data.index)"
                    b-tooltip.hover="form.items.length <= 1 ? 'At least one item is required' : 'Remove item'"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </template>
              </b-table>
            </b-card-body>

            <b-card-body class="invoice-padding invoice-summary">
              <b-row>
                <b-col cols="12">
                  <div class="table table-borderless w-100">
                    <div
                      class="d-flex justify-content-between py-1 border-bottom"
                    >
                      <div class="font-weight-bold">Subtotal:</div>
                      <div>{{ subtotal }}</div>
                    </div>

                    <!-- Discount -->
                    <!-- Discount -->
                    <div
                      class="d-flex justify-content-between py-1 border-bottom align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          v-model="settings.discount.enabled"
                          class="mr-2"
                        />
                        <div class="font-weight-bold">Discount:</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <b-form-input
                            v-model.number="form.discount"
                            type="number"
                            min="0"
                            step="0.01"
                            size="sm"
                            class="mr-1"
                            style="width: 100px"
                            :disabled="!settings.discount.enabled"
                            @input="calculateTotals"
                          />
                          <div
                            v-if="validationErrors.discount"
                            class="text-danger font-weight-bold mt-1"
                          >
                            {{ validationErrors.discount }}
                          </div>
                        </div>

                        <span>{{ form.discount }}</span>
                      </div>
                    </div>

                    <!-- Tax -->
                    <div
                      class="d-flex justify-content-between py-1 border-bottom align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          v-model="settings.tax.enabled"
                          class="mr-2"
                        />
                        <div class="font-weight-bold">Tax (%):</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <b-form-input
                            v-model.number="form.tax"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            size="sm"
                            class="mr-1"
                            style="width: 100px"
                            :disabled="!settings.tax.enabled"
                            @input="calculateTaxAmount"
                          />
                          <div
                            v-if="validationErrors.tax"
                            class="text-danger font-weight-bold mt-1"
                          >
                            {{ validationErrors.tax }}
                          </div>
                        </div>
                        <span>{{ taxAmount }}</span>
                      </div>
                    </div>

                    <!-- VAT -->
                    <div
                      class="d-flex justify-content-between py-1 border-bottom align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          v-model="settings.vat.enabled"
                          class="mr-2"
                        />
                        <div class="font-weight-bold">VAT (%):</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <b-form-input
                            v-model.number="form.vat"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            size="sm"
                            class="mr-1"
                            :disabled="!settings.vat.enabled"
                            style="width: 100px"
                            @input="calculateVatAmount"
                          />
                          <div
                            v-if="validationErrors.vat"
                            class="text-danger font-weight-bold mt-1"
                          >
                            {{ validationErrors.vat }}
                          </div>
                        </div>
                        <span>{{ vatAmount }}</span>
                      </div>
                    </div>

                    <!-- Due Amount -->
                    <div
                      class="d-flex justify-content-between py-1 border-bottom align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <input
                          type="checkbox"
                          v-model="settings.due_amount.enabled"
                          class="mr-2"
                        />
                        <div class="font-weight-bold">Due Amount:</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <b-form-input
                            v-model.number="form.due_amount"
                            type="number"
                            min="0"
                            step="0.01"
                            size="sm"
                            class="mr-1"
                            style="width: 100px"
                            :disabled="!settings.due_amount.enabled"
                            @input="calculateDueAmount"
                          />
                          <div
                            v-if="validationErrors.due_amount"
                            class="text-danger font-weight-bold mt-1"
                          >
                            {{ validationErrors.due_amount }}
                          </div>
                        </div>
                        <span>{{ form.due_amount }}</span>
                      </div>
                    </div>

                    <!-- Total -->
                    <div class="d-flex justify-content-between py-2 border-top">
                      <div class="font-weight-bold">Total:</div>
                      <div class="font-weight-bold">
                        {{ form.total }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="12" class="mb-md-0 mb-3 mt-2">
                  <div class="d-flex align-items-center mb-2">
                    <input
                      type="checkbox"
                      v-model="settings.notes.enabled"
                      class="mr-2"
                    />
                    <h6 class="mb-0">Additional Notes</h6>
                  </div>

                  <b-form-textarea
                    :disabled="!settings.notes.enabled"
                    v-model="form.notes"
                    rows="3"
                    placeholder="Notes..."
                  />
                  <div
                    v-if="settings.notes.enabled && validationErrors.notes"
                    class="text-danger font-weight-bold mt-1"
                  >
                    {{ validationErrors.notes }}
                  </div>
                </b-col>
              </b-row>
              <template v-if="isEditMode">
                <div class="d-flex align-items-center mb-2 mt-2">
                  <input
                    type="checkbox"
                    v-model="isPaid"
                    class="mr-2"
                  />
                  <h6 class="mb-0">Is Payment Done</h6>
                </div>
              </template>

            </b-card-body>

            <!-- Form Actions -->
            <b-card-body class="invoice-padding">
              <div class="d-flex justify-content-between mt-2">
                <b-button variant="outline-secondary" @click="goBack">
                  Cancel
                </b-button>
                <div>
                  <b-button
                    variant="primary"
                    :disabled="!isFormValid"
                    @click="submitInvoice"
                  >
                    <b-spinner small v-if="loading" />
                    {{ isEditMode ? "Update Invoice" : "Create Invoice" }}
                  </b-button>
                </div>
              </div>
            </b-card-body>
          </b-card>

          <!-- Form Actions -->
        </b-form>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  BAlert,
  BLink,
  VBToggle,
  BBadge,
  BSpinner,
  BTooltip,
  BFormFile,
  BTable,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { quillEditor } from "vue-quill-editor";
import { mapGetters } from "vuex";
import InvoiceSidebarSendInvoice from "./InvoiceSidebarSendInvoice.vue";
import InvoiceSidebarAddPayment from "./InvoiceSidebarAddPayment.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
export default {
  name: "InvoiceCreateView",
  components: {
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BAlert,
    BLink,
    flatPickr,
    vSelect,
    Logo,
    InvoiceSidebarSendInvoice,
    InvoiceSidebarAddPayment,
    ValidationProvider,
    ValidationObserver,
    AppTimeline,
    AppTimelineItem,
    BBadge,
    quillEditor,
    BTooltip,
    BFormFile,
    BTable,
  },
  data() {
    return {
      form: {
        id: null,
        invoice_number: "",
        invoice_logo_view: null,
        invoice_logo: null,
        company_name: "",
        company_email: "",
        company_phone: "",
        company_address: "",
        customer_name: "",
        customer_email: "",
        customer_phone: "",
        customer_address: "",
        issue_date: new Date(),
        due_date: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), // 30 days from now
        status: 1,
        currency: "USD",
        sub_total_amount: 0,
        tax: 0,
        vat: 0,
        discount: 0,
        total: 0,
        due_amount: 0,
        notes: "",
        items: [],
      },
      isPaid: false,
      currenciesOption: [],
      settings: {
        company_name: { enabled: true },
        company_email: { enabled: true },
        company_phone: { enabled: true },
        company_address: { enabled: true },

        customer_name: { enabled: true },
        customer_email: { enabled: true },
        customer_phone: { enabled: true },
        customer_address: { enabled: true },

        invoice_logo_view: { enabled: true },

        notes: { enabled: true },

        discount: { enabled: true },
        tax: { enabled: true },
        vat: { enabled: true },
        due_amount: { enabled: true },
      },
      dateConfig: {
        dateFormat: "Y-m-d",
        allowInput: true,
      },
      itemFields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "item_name", label: "Item" },
        { key: "item_description", label: "Description" },
        { key: "quantity", label: "Qty", class: "text-center" },
        { key: "unit_price", label: "Price", class: "text-right" },
        { key: "total", label: "Total", class: "text-right" },
        { key: "actions", label: "", class: "text-right" },
      ],
      loading: false,
      validationErrors: {},
      isEditMode: false,
      invoiceId: null,
    };
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [heightTransition],
  watch: {
    // Company Fields
    "form.company_name"(val) {
      if (val) this.validationErrors.company_name = "";
    },
    "settings.company_name.enabled"(enabled) {
      if (!enabled) {
        this.form.company_name = "";
        this.validationErrors.company_name = "";
      }
    },

    "form.company_email"(val) {
      if (val) this.validationErrors.company_email = "";
    },
    "settings.company_email.enabled"(enabled) {
      if (!enabled) {
        this.form.company_email = "";
        this.validationErrors.company_email = "";
      }
    },

    "form.company_phone"(val) {
      if (val) this.validationErrors.company_phone = "";
    },
    "settings.company_phone.enabled"(enabled) {
      if (!enabled) {
        this.form.company_phone = "";
        this.validationErrors.company_phone = "";
      }
    },

    "form.company_address"(val) {
      if (val) this.validationErrors.company_address = "";
    },
    "settings.company_address.enabled"(enabled) {
      if (!enabled) {
        this.form.company_address = "";
        this.validationErrors.company_address = "";
      }
    },

    // Customer Fields
    "form.customer_name"(val) {
      if (val) this.validationErrors.customer_name = "";
    },
    "settings.customer_name.enabled"(enabled) {
      if (!enabled) {
        this.form.customer_name = "";
        this.validationErrors.customer_name = "";
      }
    },

    "form.customer_email"(val) {
      if (val) this.validationErrors.customer_email = "";
    },
    "settings.customer_email.enabled"(enabled) {
      if (!enabled) {
        this.form.customer_email = "";
        this.validationErrors.customer_email = "";
      }
    },

    "form.customer_phone"(val) {
      if (val) this.validationErrors.customer_phone = "";
    },
    "settings.customer_phone.enabled"(enabled) {
      if (!enabled) {
        this.form.customer_phone = "";
        this.validationErrors.customer_phone = "";
      }
    },

    "form.customer_address"(val) {
      if (val) this.validationErrors.customer_address = "";
    },
    "settings.customer_address.enabled"(enabled) {
      if (!enabled) {
        this.form.customer_address = "";
        this.validationErrors.customer_address = "";
      }
    },

    // Invoice
    "form.invoice_logo_view"(val) {
      if (!this.isEditMode && val) {
        this.validationErrors.invoice_logo_view = "";
      }
    },
    "settings.invoice_logo_view.enabled"(enabled) {
      if (!this.isEditMode && !enabled) {
        this.form.invoice_logo_view = "";
        this.validationErrors.invoice_logo_view = "";
      }
    },

    // Other Fields
    "form.notes"(val) {
      if (val) this.validationErrors.notes = "";
    },
    "settings.notes.enabled"(enabled) {
      if (!enabled) {
        this.form.notes = "";
        this.validationErrors.notes = "";
      }
    },

    "form.discount"(val) {
      if (val !== "" && val !== null && val !== undefined) {
        this.validationErrors.discount = "";
        this.calculateTotals();
      }
    },
    "settings.discount.enabled"(enabled) {
      if (!enabled) {
        this.form.discount = "";
        this.validationErrors.discount = "";
        this.calculateTotals();
      }
    },

    "form.tax"(val) {
      if (val !== "" && val !== null && val !== undefined) {
        this.validationErrors.tax = "";
        this.calculateTotals();
      }
    },
    "settings.tax.enabled"(enabled) {
      if (!enabled) {
        this.form.tax = "";
        this.validationErrors.tax = "";
        this.calculateTotals();
      }
    },

    "form.vat"(val) {
      if (val !== "" && val !== null && val !== undefined) {
        this.validationErrors.vat = "";
        this.calculateTotals();
      }
    },
    "settings.vat.enabled"(enabled) {
      if (!enabled) {
        this.form.vat = "";
        this.validationErrors.vat = "";
        this.calculateTotals();
      }
    },

    "form.due_amount"(val) {
      if (val !== "" && val !== null && val !== undefined) {
        this.validationErrors.due_amount = "";
        this.calculateTotals();
      }
    },
    "settings.due_amount.enabled"(enabled) {
      if (!enabled) {
        this.form.due_amount = "";
        this.validationErrors.due_amount = "";
        this.calculateTotals();
      }
    },
    "form.items": {
      handler() {
        this.calculateTotals();
      },
      deep: true, // Watch for changes inside array elements
    },
    isPaid(newVal) {
      this.form.status = newVal ? 2 : 1;
    },
    'form.status': {
      immediate: true,
      handler(val) {
        this.isPaid = val === 2;
      }
    },
    'form.currency': {
        handler(newCurrency) {
          this.updateTotalHeader(newCurrency);
        },
        immediate: true // This will run when the component is created
      }
  },

  mounted() {},
  computed: {
    subtotal() {
      return this.form.items.reduce(
        (sum, item) => sum + (Number(item.total) || 0),
        0
      );
    },
    taxAmount() {
      if (!this.settings.tax.enabled) return 0;
      return (
        (this.subtotal - (this.form.discount || 0)) *
        (Number(this.form.tax) / 100)
      );
    },
    vatAmount() {
      if (!this.settings.vat.enabled) return 0;
      return (
        (this.subtotal - (this.form.discount || 0)) *
        (Number(this.form.vat) / 100)
      );
    },
    isFormValid() {
      if (this.form.total <= 0) {
        return false;
      }

      return true;
    },
    ...mapGetters({
      authUser: "userModule/getUser",
    }),
  },
  async created() {
    const [getCurrencies] = await Promise.all([ this.getCurrencies()]);

    if (this.invoiceId || this.$route.params.id) {
      const id = this.invoiceId || this.$route.params.id;
      this.invoiceId = id;
      this.isEditMode = true;
      await this.fetchInvoice(id);
    } else {
      if (this.form.items.length === 0) {
        this.addNewItem();
      }
    }
    this.currenciesOption = getCurrencies?.data?.data?.map((item) => {
        let name = `${item?.currency}`;
        return {
          name,
          id: item?.id,
        };
      });
  },
  methods: {
    updateTotalHeader(currency) {
      const totalField = this.itemFields.find(field => field.key === 'total');
      if (totalField) {
        totalField.label = `Total (${currency})`;
      }
    },
    async getCurrencies() {
      return await this.$api.get("/api/currencies/all");
    },
    onLogoChange(event) {
      const file = event.target.files[0];
      this.form.invoice_logo = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.invoice_logo_view = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    formatDate(date, format = "YYYY-MM-DD") {
      if (!date) return "";

      // If date is a string, convert to Date object
      const dateObj = typeof date === "string" ? new Date(date) : date;

      // Check if valid date
      if (isNaN(dateObj.getTime())) return "";

      const pad = (num) => num.toString().padStart(2, "0");

      const replacements = {
        YYYY: dateObj.getFullYear(),
        MM: pad(dateObj.getMonth() + 1),
        DD: pad(dateObj.getDate()),
        HH: pad(dateObj.getHours()),
        mm: pad(dateObj.getMinutes()),
        ss: pad(dateObj.getSeconds()),
      };

      return format.replace(
        /YYYY|MM|DD|HH|mm|ss/g,
        (match) => replacements[match]
      );
    },

    async fetchInvoice(id) {
      this.loading = true;
      try {
        const { data } = await this.$api.get(`/api/general-invoices/${id}`);
        this.form = {
          ...data,
          issue_date: new Date(data.issue_date),
          due_date: new Date(data.due_date),
        };
        this.form.items.forEach((item) => {
          item.total = (item.quantity || 0) * (item.unit_price || 0);
        });
        this.form.invoice_logo_view = `${process.env.VUE_APP_API_URL}/storage/${data?.invoice_logo}`;
        this.calculateTotals();
      } catch (error) {
        console.error("Error fetching invoice:", error);
        this.showToast("danger", "Failed to load invoice data");
      } finally {
        this.loading = false;
      }
    },

    addNewItem() {
      this.form.items.push({
        item_name: "",
        quantity: 1,
        unit_price: 0,
        total: 0,
      });
    },

    removeItem(index) {
      if (this.form.items.length <= 1) {
        this.$bvToast.toast("At least one item is required.", {
          title: "Warning",
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.form.items.splice(index, 1);
      this.calculateTotals();
    },

    calculateItemTotal(item) {
      item.total = (item.quantity || 0) * (item.unit_price || 0);
      this.calculateTotals();
    },

    calculateTaxAmount() {
      this.calculateTotals();
    },

    calculateVatAmount() {
      this.calculateTotals();
    },
    calculateDueAmount() {
      this.calculateTotals();
    },

    calculateTotals() {
      // Recalculate all item totals first (in case any were missed)
      this.form.items.forEach((item) => {
        item.total = (item.quantity || 0) * (item.unit_price || 0);
      });

      // Calculate subtotal
      this.form.sub_total_amount = this.form.items.reduce(
        (sum, item) => sum + (item.total || 0),
        0
      );

      // Calculate taxable amount after discount
      const taxableAmount =
        this.form.sub_total_amount - (this.form.discount || 0);

      // Calculate tax and VAT amounts only if enabled
      const taxAmount = this.settings.tax.enabled
        ? taxableAmount * (this.form.tax / 100)
        : 0;
      const vatAmount = this.settings.vat.enabled
        ? taxableAmount * (this.form.vat / 100)
        : 0;

      // Calculate total
      let total = taxableAmount + taxAmount + vatAmount;

      // Apply due amount if enabled
      if (this.settings.due_amount.enabled) {
        total -= this.form.due_amount || 0;
      }

      // Ensure total doesn't go negative
      this.form.total = Math.max(0, total);

      // Force Vue to recognize the changes
      this.$forceUpdate();
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (
        !item.item_name ||
        !item.item_description ||
        item.quantity <= 0 ||
        item.unit_price < 0
      ) {
        return "table-danger";
      }
    },

    async submitInvoice() {
      if (!this.validateForm()) {
        return;
      }
      this.loading = true;
      try {
        // Calculate totals before submit
        this.calculateTotals();

        const formData = new FormData();

        // Basic fields
        formData.append("invoice_number", this.form.invoice_number);
        formData.append("company_id", this.authUser?.id);
        formData.append("company_name", this.form.company_name);
        formData.append("company_email", this.form.company_email);
        formData.append("company_phone", this.form.company_phone);
        formData.append("company_address", this.form.company_address);
        formData.append("customer_name", this.form.customer_name);
        formData.append("customer_email", this.form.customer_email);
        formData.append("customer_phone", this.form.customer_phone);
        formData.append("customer_address", this.form.customer_address);
        formData.append(
          "issue_date",
          this.formatDate(this.form.issue_date, "YYYY-MM-DD")
        );
        formData.append(
          "due_date",
          this.formatDate(this.form.due_date, "YYYY-MM-DD")
        );
        formData.append("sub_total_amount", this.form.sub_total_amount);
        formData.append("tax", this.form.tax);
        formData.append("vat", this.form.vat);
        formData.append("discount", this.form.discount);
        formData.append("total", Math.ceil(Number(this.form.total)));
        formData.append("due_amount", this.form.due_amount);
        formData.append("currency", this.form.currency);
        formData.append("notes", this.form.notes);
        formData.append("status", this.form.status);

        // If there's an image or file upload field
        if (this.form.invoice_logo) {
          formData.append("invoice_logo", this.form.invoice_logo); // assumes it's a File object from <input type="file">
        }

        // Handle items array (important!)
        this.form.items.forEach((item, index) => {
          formData.append(`items[${index}][item_code]`, item.item_code);
          formData.append(`items[${index}][item_name]`, item.item_name);
          formData.append(
            `items[${index}][item_description]`,
            item.item_description
          );
          formData.append(`items[${index}][quantity]`, item.quantity);
          formData.append(`items[${index}][unit_price]`, item.unit_price);
          formData.append(`items[${index}][total]`, item.total);
        });

        let response;
        if (this.isEditMode) {
          formData.append("updated_by", this.authUser?.id);
          formData.append("_method", "PUT");
          console.log(Object.fromEntries(formData.entries()));
          response = await this.$api.post(
            `/api/general-invoices/${this.invoiceId}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        } else {
          formData.append("created_by", this.authUser?.id);
          response = await this.$api.post("/api/general-invoices", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }

        this.showToast("success", "Invoice saved successfully!");
        this.$router.push({ name: "admin-general-invoices" });

        // Show success message
        this.showToast("success", "Invoice saved successfully!");

        // Redirect to invoices list
        this.$router.push({ name: "admin-general-invoices" });
      } catch (error) {
        if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        let messages = [];

        for (const key in errors) {
          if (errors.hasOwnProperty(key)) {
            messages.push(...errors[key]); // collect all messages
          }
        }

        // Optionally show all error messages in toasts or a single joined message
        messages.forEach(msg => this.showToast("danger", msg));
        // OR show all at once: this.showToast("danger", messages.join('\n'));
      } else {
        this.showToast("danger", "Failed to save invoice. Please try again.");
      }
      } finally {
        this.loading = false;
      }
    },

    validateForm() {
      const errors = {};

      // Company Fields
      if (this.settings.company_name.enabled && !this.form.company_name) {
        errors.company_name = "Company Name is required.";
      }
      if (this.settings.company_email.enabled && !this.form.company_email) {
        errors.company_email = "Company Email is required.";
      }
      if (this.settings.company_phone.enabled && !this.form.company_phone) {
        errors.company_phone = "Company Phone is required.";
      }
      if (this.settings.company_address.enabled && !this.form.company_address) {
        errors.company_address = "Company Address is required.";
      }

      // Customer Fields
      if (this.settings.customer_name.enabled && !this.form.customer_name) {
        errors.customer_name = "Customer Name is required.";
      }
      if (this.settings.customer_email.enabled && !this.form.customer_email) {
        errors.customer_email = "Customer Email is required.";
      }
      if (this.settings.customer_phone.enabled && !this.form.customer_phone) {
        errors.customer_phone = "Customer Phone is required.";
      }
      if (
        this.settings.customer_address.enabled &&
        !this.form.customer_address
      ) {
        errors.customer_address = "Customer Address is required.";
      }

      // Invoice Fields
      if (
        this.settings.invoice_logo_view.enabled &&
        !this.form.invoice_logo_view
      ) {
        errors.invoice_logo_view = "Invoice Logo is required.";
      }

      // Other Fields
      if (this.settings.notes.enabled && !this.form.notes) {
        errors.notes = "Notes are required.";
      }

      if (
        this.settings.discount.enabled &&
        (this.form.discount === undefined ||
          this.form.discount === null ||
          this.form.discount === "")
      ) {
        errors.discount = "Discount is required.";
      }

      if (
        this.settings.tax.enabled &&
        (this.form.tax === undefined ||
          this.form.tax === null ||
          this.form.tax === "")
      ) {
        errors.tax = "Tax is required.";
      }

      if (
        this.settings.vat.enabled &&
        (this.form.vat === undefined ||
          this.form.vat === null ||
          this.form.vat === "")
      ) {
        errors.vat = "VAT is required.";
      }

      if (
        this.settings.due_amount.enabled &&
        (this.form.due_amount === undefined ||
          this.form.due_amount === null ||
          this.form.due_amount === "")
      ) {
        errors.due_amount = "Due amount is required.";
      }

      this.validationErrors = errors;

      return Object.keys(errors).length === 0;
    },

    showToast(variant, message) {
      this.$bvToast.toast(message, {
        title: variant === "success" ? "Success" : "Error",
        variant,
        solid: true,
      });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

  <style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

@import "@core/scss/vue/libs/quill.scss";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}

.custom-width {
  max-width: 25rem !important;
}

/* Fullscreen mode */
.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Adjust editor and toolbar in fullscreen mode */
.fullscreen .ql-container {
  height: calc(100vh - 50px) !important;
}

.fullscreen .ql-toolbar {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
  padding: 10px;
}

/* Fullscreen button styling */
.fullscreen-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  margin-left: 10px;
}
</style>
